import { query } from 'utils/graphql';
import { SAVE_SUCCESS } from './pageBuilder';

const LOAD_PAGES_FOR_SETTINGS = 'voyager/pages/LOAD_PAGES_FOR_SETTINGS';
const LOAD_PAGES_FOR_SETTINGS_SUCCESS = 'voyager/pages/LOAD_PAGES_FOR_SETTINGS_SUCCESS'; // eslint-disable-line id-length
const LOAD_PAGES_FOR_SETTINGS_FAIL = 'voyager/pages/LOAD_PAGES_FOR_SETTINGS_FAIL';
const LOAD_PAGE_FOR_SETTINGS = 'voyager/pages/LOAD_PAGE_FOR_SETTINGS';
const LOAD_PAGE_FOR_SETTINGS_SUCCESS = 'voyager/pages/LOAD_PAGE_FOR_SETTINGS_SUCCESS';
const LOAD_PAGE_FOR_SETTINGS_FAIL = 'voyager/pages/LOAD_PAGE_FOR_SETTINGS_FAIL';
const LOAD_PARENT_FOR_SETTINGS = 'voyager/pages/LOAD_PARENT_FOR_SETTINGS';
const LOAD_PARENT_FOR_SETTINGS_SUCCESS = 'voyager/pages/LOAD_PARENT_FOR_SETTINGS_SUCCESS'; // eslint-disable-line id-length
const LOAD_PARENT_FOR_SETTINGS_FAIL = 'voyager/pages/LOAD_PARENT_FOR_SETTINGS_FAIL';
const LOAD_PATHS = 'voyager/pages/LOAD_PATHS';
const LOAD_PATHS_SUCCESS = 'voyager/pages/LOAD_PATHS_SUCCESS';
const LOAD_PATHS_FAIL = 'voyager/pages/LOAD_PATHS_FAIL';

const initialState = {
  pages: [],
  selectedPage: null,
  parentPage: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_PAGES_FOR_SETTINGS: {
      return {
        ...state,
        loaded: false,
      };
    }
    case LOAD_PAGES_FOR_SETTINGS_SUCCESS: {
      return {
        ...state,
        loaded: true,
        pages: action.data.pages,
      };
    }
    case LOAD_PAGE_FOR_SETTINGS_SUCCESS: {
      return {
        ...state,
        selectedPage: action.data.page,
      };
    }
    case LOAD_PARENT_FOR_SETTINGS_SUCCESS: {
      return {
        ...state,
        parentPage: action.data.page,
      };
    }
    case SAVE_SUCCESS: {
      return {
        ...state,
        selectedPage: action.page && action.page.id === state.selectedPage.id ? action.page : state.selectedPage,
        pages: action.page
          ? state.pages.map(page => (page.id === action.page.id ? action.page : page))
          : state.pages,
      };
    }
    case LOAD_PATHS_SUCCESS: {
      return {
        ...state,
        pathsLoaded: true,
        paths: action.data.pages.map(({ path }) => path),
      };
    }
    case LOAD_PATHS_FAIL: {
      return {
        ...state,
        pathsLoading: false,
        paths: [],
      };
    }
    default:
      return state;
  }
}

const pagePropsForSettings = `
  id
  live
  facilityId
  locale
  facility {
    address {
      fullAddress
    }
  }
  metadata {
    type
    title
    internalPageName
  }
  childPageIds
  children {
    pageId
    locale
  }
`;

const pageProps = `
id
companyId
facilityId
disableEnUsPage
facility {
  id
  displayName
  brandName
  facilityType
  linkOutUrl
  primaryImage
  address {
    address1
    address2
    city
    state
    postal
    country
    latitude
    longitude
    fullAddress
  }
  enabled
}
metadata {
  description
  linkOut
  slug
  title
  internalPageName
  titlePostfix
  type
  noIndex
  customUrl
  metaTags {
    property
    content
  }
  syncOGTags
  canonical
}
boilerplate
live
path
publishedVersion {
  createdAt
  id
}
versions {
  id
  createdAt
}
version {
  id
  createdAt
}
locale
siblings
parent
childPageIds
children {
  pageId
  lastUpdated
  lastPublished
  locale
  status {
    id
    context
    text
  }
}
`;

const parentProps = `
  id
  metadata {
    internalPageName
  }
`;

export const loadPagesForSettings = () => ({
  types: [LOAD_PAGES_FOR_SETTINGS, LOAD_PAGES_FOR_SETTINGS_SUCCESS, LOAD_PAGES_FOR_SETTINGS_FAIL],
  force: true,
  promise: query`
    query GetPagesForSettings {
      pages(locale: "en-us") {
        ${pagePropsForSettings}
      }
    }
  `,
});

export const loadPage = id => ({
  types: [LOAD_PAGE_FOR_SETTINGS, LOAD_PAGE_FOR_SETTINGS_SUCCESS, LOAD_PAGE_FOR_SETTINGS_FAIL],
  force: true,
  promise: query`
    query GetPageForSettings {
      page(id: "${id}") {
        ${pageProps}
      }
    }
  `,
});

export const loadParentPage = id => ({
  types: [LOAD_PARENT_FOR_SETTINGS, LOAD_PARENT_FOR_SETTINGS_SUCCESS, LOAD_PARENT_FOR_SETTINGS_FAIL],
  force: true,
  promise: query`
    query GetParentPageForSettings {
      page(id: "${id}") {
        ${parentProps}
      }
    }
  `,
});

export const loadPaths = () => ({
  types: [LOAD_PATHS, LOAD_PATHS_SUCCESS, LOAD_PATHS_FAIL],
  force: true,
  promise: query`
    query getPagePaths {
      pages {
        metadata {
          slug
        }
        locale
        path
      }
    }
  `,
});

// Selectors
export const getPagesForSettings = state => state.pageSettings.pages;

export const getPagesForSettingsLoaded = state => state.pageSettings.loaded;

export const getPaths = state => state.pageSettings.paths;

export const getPathsLoaded = state => state.pageSettings.pathsLoaded;

export const getSelectedPage = state => state.pageSettings.selectedPage;

export const getPagesLoaded = state => state.pageSettings.loaded;

export const getParentPage = state => state.pageSettings.parentPage;
